export enum Access {
  Granted = 'Granted',
  Denied = 'Denied',
  Actionable = 'Actionable'
}

export default Access;
